'use client';

import orderBlockAddToWishlistTrigger from '@coolblue-development/ga4-events/triggers/OrderBlock/addToWishlistTrigger';
import orderBlockRemoveFromWishlistTrigger from '@coolblue-development/ga4-events/triggers/OrderBlock/removeFromWishlistTrigger';
import orderBlockSummaryAddToWishlistTrigger from '@coolblue-development/ga4-events/triggers/OrderBlockSummary/addToWishlistTrigger';
import orderBlockSummaryRemoveFromWishlistTrigger from '@coolblue-development/ga4-events/triggers/OrderBlockSummary/removeFromWishlistTrigger';
import stickyHeaderAddToWishlistTrigger from '@coolblue-development/ga4-events/triggers/StickyHeader/addToWishlistTrigger';
import stickyHeaderRemoveFromWishlistTrigger from '@coolblue-development/ga4-events/triggers/StickyHeader/removeFromWishlistTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { WishlistToggleButton } from '@coolblue-development/next-wishlist/client';

import CustomSinterklaasIcon from './CustomSinterklaasIcon';

type WishlistButtonProps = {
  feature: 'order_block' | 'sticky_header' | 'order_summary';
  productId: number;
  variant?: 'compact' | 'default';
  isInSinterklaasSplitTest?: boolean;
};

export const WishlistButton = ({
  feature,
  productId,
  variant = 'compact',
  isInSinterklaasSplitTest = false
}: WishlistButtonProps) => {
  const { trackEvent } = useAnalytics();

  const addToWishListTrigger = {
    order_block: orderBlockAddToWishlistTrigger,
    sticky_header: stickyHeaderAddToWishlistTrigger,
    order_summary: orderBlockSummaryAddToWishlistTrigger
  }[feature];

  const removeFromWishListTrigger = {
    order_block: orderBlockRemoveFromWishlistTrigger,
    sticky_header: stickyHeaderRemoveFromWishlistTrigger,
    order_summary: orderBlockSummaryRemoveFromWishlistTrigger
  }[feature];

  function onWishlistClick({ nextState }: { currentState: boolean; nextState: boolean }) {
    if (nextState) {
      trackEvent(
        addToWishListTrigger({
          item_id: productId
        })
      );

      return;
    }

    trackEvent(
      removeFromWishListTrigger({
        total_indices: 1,
        index: 1,
        item_id: productId
      })
    );
  }

  const customIcons = isInSinterklaasSplitTest ? { inWishlistIcon: <CustomSinterklaasIcon /> } : {};

  return (
    <WishlistToggleButton
      onClick={onWishlistClick}
      productId={productId}
      variant={variant}
      {...customIcons}
    />
  );
};
